<template>
  <div class="account-wrapper">
    <b-tabs
      content-class="mt-3"
      small
      card
    >
      <b-tab
        v-if="$hasRole(['employer'])"
        :title="$t('pages.my-account.tabs.payments', 'Payments')"
        :active="!isNotif"
      >
        <Payments />
      </b-tab>
      <b-tab
        v-if="$hasRole(['employer'])"
        :title="$t('pages.my-account.tabs.company', 'Company')"
        :active="isCompany"
      >
        <Company />
      </b-tab>
      <b-tab
        :title="$t('pages.my-account.tabs.profile', 'Profile')"
        :active="isProfile"
        class="profile-tab"
      >
        <Profile />
      </b-tab>
      <b-tab
        :title="$t('pages.my-account.tabs.notifications', 'Notifications')"
        :active="isNotif"
      >
        <Notifications />
      </b-tab>
      <b-tab
        v-if="$hasRole(['employer'])"
        :title="$t('pages.my-account.tabs.promo-codes', 'Promo codes')"
      >
        <MyPromoCodes />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Payments from '@/components/jobs/employer/Payments';
import Company from '@/components/company/Company';
import Profile from '@/views/jobs/Profile';
import Notifications from '@/components/Notifications';
import MyPromoCodes from '@/components/MyPromoCodes';

export default {
  components: {
    Payments,
    Company,
    Profile,
    Notifications,
    MyPromoCodes
  },
  data() {
    return {
      isNotif: false,
      isProfile: false,
      isCompany: false
    }
  },
  mounted() {
    this.isNotif = this.$route.query.notifications ? true : false;
    this.isProfile = this.$route.query.profile ? true : false;
    this.isCompany = this.$route.query.company ? true : false;
  }
}
</script>

<style lang="scss" scoped>
  .account-wrapper {
    text-align: left;
  }

  @media screen and (max-width: 767px) {
    .profile-tab {
      padding: 0;
    }
  }
</style>

<style>
  @media screen and (max-width: 767px) {
    li {
      width: 100%;
      text-align: center;
    }
  }
</style>

